import React from 'react';
import { Island } from '../../../../../components/island/Island';
import './screenshot.scss';
var ScreenshotContainer = function ScreenshotContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot"
  }, children)));
};
import { useRive } from '@rive-app/react-canvas';
export var RiveEmbed = function RiveEmbed(_ref2) {
  var riveUrl = _ref2.riveUrl;
  // TEMP - prototype code for checking which Rive embed approach works best
  var query = new URLSearchParams(window.location.search);
  var useIframe = !!query.get('riveIframe');
  if (useIframe) {
    return /*#__PURE__*/React.createElement("iframe", {
      className: "screenshot-rive",
      src: "https://rive.app/s/b8wAhR4M7kyeMj1HYVYU3g/embed?runtime=rive-renderer",
      allow: "autoplay"
    });
  }
  var _useRive = useRive({
      src: riveUrl,
      autoplay: true
    }),
    RiveComponent = _useRive.RiveComponent;
  return /*#__PURE__*/React.createElement(RiveComponent, {
    className: "screenshot-rive"
  });
};
export var Screenshot = function Screenshot(_ref3) {
  var image = _ref3.image,
    riveUrl = _ref3.riveUrl;
  if (riveUrl) {
    return /*#__PURE__*/React.createElement(ScreenshotContainer, null, /*#__PURE__*/React.createElement(Island, {
      Component: RiveEmbed,
      riveUrl: riveUrl
    }));
  }
  return /*#__PURE__*/React.createElement(ScreenshotContainer, null, image && /*#__PURE__*/React.createElement("img", {
    src: image,
    className: "screenshot-image",
    alt: "Screenshot of Milanote"
  }));
};